import { Component, Input } from '@angular/core';
import { FileStoreAPIService } from 'src/app/extensions/services/api/file-store-api.service';

@Component({
  selector: 'preview-documents',
  standalone: false,
  templateUrl: './preview-documents.component.html',
  styleUrl: './preview-documents.component.scss',
})
export class PreviewDocumentsComponent {
  @Input() specialOffer: app.models.GetSpecialOfferClientModel;
  constructor(private _fileStoreAPIService: FileStoreAPIService) {}

  public downloadAllDocuments(): void {
    this.specialOffer.campaignDocuments.forEach(document => {
      this.downloadDocument(document);
    });
  }

  public downloadDocument(file: app.models.SpecialOfferXDocument): void {
    if (file.documentStoragePath) {
      this._fileStoreAPIService.getFile(file.documentStoragePath).subscribe(response => {
        if (response) {
          const documentRef = `data:application/pdf;base64,${response}`;
          const downloadLink = document.createElement('a');

          downloadLink.href = documentRef;
          downloadLink.download = file.documentName;
          downloadLink.click();
        }
      });
    }
  }

  public getFileTypeIcon(filename: string): string {
    const extension = filename.split('.').pop()?.toLowerCase();

    switch (extension) {
      case 'pdf':
        return 'file-pdf';
      case 'doc':
      case 'docx':
        return 'file-word';
      default:
        return 'file-pdf';
    }
  }
}
